import { Record } from 'immutable';

const ScoreBandRecord = Record({
  id: undefined,
  name: undefined,
  scorePercentageFrom: undefined,
  scorePercentageTo: undefined,
  interpretation: undefined,
  language: undefined,
});

class ScoreBand extends ScoreBandRecord { }

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'id':
      return [key, `${val}`];
    default:
      return [key, val];
  }
};

ScoreBand.create = (data) =>
  new ScoreBand(data).mapEntries(reviver);

export default ScoreBand;



// WEBPACK FOOTER //
// ./data/ScoreBand/model.js